import React from "react";
import {DatePicker, Form, Input, Table} from "antd";
import ItemInput from "../ItemInput/ItemInput";
import SubObjectInjury from "../../../FormInput/components/SubObjectInjury/SubObjectInjury";
const TableInput = props => {
  const {catalog, objectsShow, formRef, childrenName} = props;
  const columns = catalog.components.map(e => {
    return {
      key: e.name,
      dataIndex: e.name,
      title: e.title,
      type: e.type,
    };
  });

  const mergedColumns = columns.map(col => {
    return {
      ...col,
      onCell: (record: any, index: number) => ({
        record,
        dataIndex: col.dataIndex,
        name: [
          ...childrenName,
          catalog.name,
          objectsShow[index].name,
          col.dataIndex,
        ],
        type: objectsShow[index].components.find(e => e.name == col.dataIndex)
          .type,
        values: objectsShow[index].components.find(e => e.name == col.dataIndex)
          .values,
        otherType:
          col.dataIndex == "MoreOptions"
            ? objectsShow[index].components.find(e => e.name == col.dataIndex)
                .otherType
            : null,
        // values: [1, 2, 3],
      }),
    };
  });
  interface EditableRowProps {
    index: number;
  }

  // console.log(mergedColumns);
  const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
    if (props["data-row-key"] == "Injury/Trauma") {
      return (
        <>
          <tr {...props}></tr>
          <tr>
            <td></td>
            <td colSpan={10}>
              <SubObjectInjury></SubObjectInjury>{" "}
            </td>
          </tr>
        </>
      );
    } else {
      return <tr {...props}></tr>;
    }
  };
  interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    record: any;
    index: number;
    children: React.ReactNode;
    name: any;
    type: string;
    values: any;
    otherType: any;
  }

  const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    name,
    type,
    values,
    otherType,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {dataIndex == "Name" ? (
          <span style={{fontWeight: 600}}>{record.key}</span>
        ) : (
          <ItemInput
            formRef={formRef}
            name={name}
            type={type}
            values={values}
            otherType={otherType}
          ></ItemInput>
        )}
      </td>
    );
  };

  const dataSource = objectsShow.map(e => {
    let data = {
      key: e.name,
    };
    catalog.components?.forEach(element => {
      data[element.name] = "";
    });
    // 
    return data;
  });
  return (
    <div>
      <Table
        bordered
        components={{
          body: {
            cell: EditableCell,
            row: EditableRow,
          },
        }}
        // expandedRowRender={record => <p style={{margin: 0}}>{123}</p>}
        columns={mergedColumns}
        dataSource={dataSource}
        pagination={false}
      ></Table>
    </div>
  );
};
export default TableInput;
